import { AxiosError } from 'axios';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import SingleSelect from '../../../../components/SingleSelect';
import { backendErrorNotification } from '../../../../components/Notification';
import { reportFunctionsApi } from '../../../../services/requests';
import type { ReportFunctionGet } from '../../../../types/apiResponse/reports';

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  currentFunction?: ReportFunctionGet | null;
}

export default function ReportFunctionSelect({ value, onChange, disabled, currentFunction }: Props) {
  const [functions, setFunctions] = useState<ReportFunctionGet[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const response = await reportFunctionsApi.get();
        if (response.status !== 200 || response.data.success === false) throw response;
        if (!cancelled) setFunctions(response.data.data);
      } catch (error) {
        if (!cancelled) {
          setFailed(true);
          backendErrorNotification(error as AxiosError);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void load();
    return () => { cancelled = true; };
  }, []);

  const options = [
    { value: '', label: t('reportNoFunction') },
    ...functions.map((item) => ({ value: String(item.id), label: item.label })),
  ];
  const selected = options.find((option) => option.value === value)
    || (value ? { value, label: currentFunction?.label || value } : options[0]);

  return (
    <SingleSelect
      value={selected}
      options={options}
      onChange={(option: any) => onChange(option?.value || '')}
      disabled={disabled || loading || failed}
      placeholder={t('reportFunction')}
    />
  );
}
